import { SystemIcons } from '@almbrand/systemicons';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import styles from './LicensePlateInput.module.scss';

export interface LicensePlateInputProps {
	hasError?: boolean;
	onChange?: (formatted: string) => void;
}

export const LicensePlateInput: React.FC<LicensePlateInputProps> = ({ hasError = false, onChange }) => {
	const [value, setValue] = useState('');
	const [focusBorder, setFocusBorder] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		const formatted = formatLicensePlate(value);

		setValue(formatted);

		onChange?.(formatted);
	};

	const handleContainerClick = () => {
		inputRef.current?.focus();
	};

	const formatLicensePlate = (value: string) => {
		// Remove all non-alphanumeric characters
		const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

		// Format: AA 12 35B
		let formatted = '';
		for (let i = 0; i < cleaned.length && i < 7; i++) {
			formatted += cleaned[i];
			if (i === 1 || i === 3 || i === 6) formatted += ' ';
		}
		return formatted.trim();
	};

	const handleOnFocus = (event: React.FocusEvent<HTMLInputElement>) => {
		setFocusBorder(true);
	};

	return (
		<div
			className={classNames(
				styles.LicensePlateInput,
				hasError && styles['LicensePlateInput--error'],
				focusBorder && styles['LicensePlateInput--border']
			)}
			onClick={handleContainerClick}
			onBlur={() => setFocusBorder(false)}
		>
			<div className={classNames(styles.LicensePlateInput__icon)}>
				<SystemIcons
					height={23}
					width={23}
					themeName={'Codan-theme'}
					icon={'EU'}
				/>
				<span>DK</span>
			</div>
			<div className={classNames(styles.LicensePlateInput__inputWrapper)}>
				{!value && <div className={classNames(styles.LicensePlateInput__placeholder)}>AA 12 345</div>}

				<div className={classNames(styles.LicensePlateInput__input)}>
					<input
						ref={inputRef}
						name='name'
						type='text'
						onChange={handleOnChange}
						onFocus={handleOnFocus}
						value={value}
						autoComplete='off'
						maxLength={9}
					/>
				</div>
			</div>
		</div>
	);
};
